// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeaderStatic_header__1qgZk","nakedHeader":"PageHeaderStatic_nakedHeader__XwNpW","headerContent":"PageHeaderStatic_headerContent__jGoeM"};